import { render } from "./MarketingConfigureErrorPage.vue?vue&type=template&id=24653098&scoped=true"
import script from "./MarketingConfigureErrorPage.vue?vue&type=script&lang=js"
export * from "./MarketingConfigureErrorPage.vue?vue&type=script&lang=js"

import "./MarketingConfigureErrorPage.vue?vue&type=style&index=0&id=24653098&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24653098"]])

export default __exports__